import runActions from '../utils/api/runActions'

class RedirectButton {
  root

  constructor(root: any) {
    this.root = root
  }

  redirectButtonHandler = async () => {
    try {
      const { ProgressStore, StepsStore } = this.root
      StepsStore.isApiLoading = true
      await this.checkAllValidate()
      const [result, firstErrorName] =
        ProgressStore.nextStepStatus(StepsStore.currentStep)
      console.log('result--->', result)
      StepsStore.firstErrorName = firstErrorName
      if (result) {
        const actions = StepsStore.stepsSetting[StepsStore.currentStep].actions || null
        if (actions) {
          // this.root.StepsStore.isApiLoading = true

          const data = await runActions(
            StepsStore.stepsStoreApi,
            actions,
            StepsStore.values,
            StepsStore.stepsInputs[StepsStore.currentStep],
            StepsStore.lff_uid
          )
          //const data = await runActions(actions, this.values)
          console.log('data.status--->', data)
          if (data.status) {
            StepsStore.showSpinner = true

            if (data.utm) {
              this.root.StepsStore.stepsStoreConfig.setShortData({ utm: data.utm })
            }

            this.handleRedirect()
          } else {

            StepsStore.apiErrors = {
              ...StepsStore.apiErrors,
              ...data.errors,
            }
            if (data.error) {
              StepsStore.apiErrors.error = data.error
            }
          }
          
        } else {
          this.handleRedirect()
        }
      } else {
        StepsStore.setNeedsToScroll(true)
      }
      //this.showSpinner = false
      StepsStore.isApiLoading = false
    } catch (error) {
      console.log(error)
      
    }
  }

  checkAllValidate = async () => {
    console.log('checkAllValidate')
    const {
      validsAsync
    } = this.root.StepsStore

    const requests = Object.values(validsAsync)
      .filter(request => request !== false)
      //@ts-ignore
      .map(request => request.promise);

    try {
      console.log('checkAllValidate 2')
      await Promise.all(requests);
    } catch (error) {
      console.error(error);
    }

    console.log('checkAllValidate 3')
    // this.checkAllStatus();

  }

  handleRedirect = () => {
    console.log('redirect')
    const { StepsStore } = this.root
    StepsStore.stepsStoreConfig.finish({
      lff_uid: StepsStore.lff_uid,
      finish: StepsStore.stepsStoreApi.finish
    })
  }
}

export default RedirectButton